import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { IBudget, IBudgetForm } from "../../data/entities";
import { BudgetRepoImpl } from "../../data/repo";

export const budgetRedux = generateCrudRedux<IBudget, IBudgetForm>({
  actionTypeName: "Budget",
  repository: BudgetRepoImpl,
});

export interface IBudgetReduxState extends ICRUDReduxState<IBudget> {}

export const BudgetReducers = combineReducers<IBudgetReduxState>({
  ...budgetRedux.reducer,
});
